import React from 'react';
import clsx from 'clsx';

import styles from './DayEvent.module.scss';

export function DayEventWorkingHours() {
  return (<div className={clsx(styles.dayEventRoot, styles.dayEventWorkingHours)} />);
}
